import type { IByggDokument } from './IByggDokument';

export class ByggDokument implements IByggDokument {
    public static parseObject(obj: any): ByggDokument {
        try {
            return new ByggDokument(obj);
        } catch (error) {
            throw new Error(
                `Not able to parse ByggDokument object, object attempted to parse is: ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    public get bucketFilnavn() {
        return this._bucketFilnavn;
    }

    public get byggNummer() {
        return this._byggNummer;
    }

    public get etasje() {
        return this._etasje;
    }

    public get fag() {
        return this._fag;
    }

    public get fdvWebByggId() {
        return this._fdvWebByggId;
    }

    public get id() {
        return this._id;
    }

    public get kategori() {
        return this._kategori;
    }

    public get maalestokk() {
        return this._maalestokk;
    }

    public get navn() {
        return this._navn;
    }
    public set navn(value) {
        this._navn = value;
    }

    public get nummer() {
        return this._nummer;
    }
    public set nummer(value) {
        this._nummer = value;
    }

    public get revdato() {
        return this._revdato;
    }
    public set revdato(value) {
        this._revdato = value ? new Date(value) : null;
    }

    public get type() {
        return this._type;
    }
    private _bucketFilnavn: string;
    private _byggNummer: string;
    private _etasje: string;
    private _fag: string;
    private _fdvWebByggId: string;
    private _id: number;
    private _kategori: string;
    private _maalestokk: string;
    private _navn: string;
    private _nummer: string;
    private _revdato: Date | null;
    private _type: string;

    constructor(obj: IByggDokument) {
        this._bucketFilnavn = obj.bucketFilnavn;
        this._byggNummer = obj.byggNummer;
        this._etasje = obj.etasje;
        this._fag = obj.fag;
        this._fdvWebByggId = obj.fdvWebByggId;
        this._id = obj.id;
        this._kategori = obj.kategori;
        this._maalestokk = obj.maalestokk;
        this._navn = obj.navn;
        this._nummer = obj.nummer;
        this._revdato = obj.revdato ? new Date(obj.revdato) : null;
        this._type = obj.type;
    }
}
